import React, { useEffect, useState } from "react";
import { db } from "../firebase";
import { collection, getDocs, query, orderBy } from "firebase/firestore";
import { Card, Col, Row } from "react-bootstrap";
import { motion } from "framer-motion";

export default function Fasilitas() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const q = query(collection(db, "fasilitas"), orderBy("nama", "asc"));
        const snap = await getDocs(q);
        const data = snap.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setList(data);
      } catch (err) {
        console.error("fetch fasilitas error:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading)
    return <p className="text-center mt-4">Memuat fasilitas...</p>;
  if (list.length === 0)
    return <p className="text-center mt-4">Belum ada fasilitas.</p>;

  return (
    <section
      className="py-5 fasilitas-section"
      style={{
        background:
          "linear-gradient(to bottom, #ffffff 0%, #e8f1ff 50%, #ffffff 100%)",
      }}
    >
      <div className="container">
        <h2
          className="fw-bold mb-5 text-center"
          style={{ color: "#0d47a1" }}
        >
          Fasilitas Sekolah
        </h2>

        <Row className="g-4">
          {list.map((f, idx) => (
            <Col key={f.id} xs={12} sm={6} md={4} lg={3}>
              <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: idx * 0.12 }}
              >
                <Card
                  className="h-100 border-0 shadow-sm fasilitas-card"
                  style={{
                    borderRadius: "16px",
                    overflow: "hidden",
                    transition: "all 0.35s ease",
                  }}
                >
                  {f.gambar && (
                    <div style={{ overflow: "hidden" }}>
                      <Card.Img
                        variant="top"
                        src={f.gambar}
                        alt={f.nama}
                        style={{
                          height: "200px",
                          objectFit: "cover",
                          transition: "transform 0.5s ease",
                        }}
                      />
                    </div>
                  )}

                  <Card.Body
                    className="text-center p-3"
                    style={{
                      background:
                        "linear-gradient(135deg, #ffffff, #f1f6ff)",
                    }}
                  >
                    <Card.Title
                      className="fw-semibold mb-2"
                      style={{ color: "#1b5e20" }}
                    >
                      {f.nama}
                    </Card.Title>

                    {f.deskripsi && (
                      <Card.Text className="text-muted small">
                        {f.deskripsi}
                      </Card.Text>
                    )}
                  </Card.Body>
                </Card>
              </motion.div>
            </Col>
          ))}
        </Row>
      </div>

      {/* Hover effect khusus */}
      <style>
        {`
          .fasilitas-card:hover {
            transform: translateY(-8px);
            box-shadow: 0 14px 30px rgba(0,0,0,0.15);
          }

          .fasilitas-card:hover img {
            transform: scale(1.08);
          }
        `}
      </style>
    </section>
  );
}
